export default {
  hasClaim(type, value) {

    const token = this.getToken();
    if(token === null) return;

    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    const decoded = JSON.parse(jsonPayload);
    const decodedType = decoded[type];
    if(decodedType !== undefined) {
      if(value === undefined) return true;

      if(Array.isArray(decodedType)){
        return decodedType.find( d=> d === value);
      }

      return decoded[type] === value;
    }

  },
  getToken() {
    return window.$cookies.get('auth');
  }
}

